import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { RemoteAction } from '../../remote-action';
import { AppService } from 'src/app/_services/app-service/logic/app.service';
import { CredentialsService } from 'src/app/_services/credentials/logic/credentials.service';
import { ServiceRemoteActionBuilder } from '../service-remote-action-builder';
import { GpsRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/gps-remote-action-builder-service-step/gps-remote-action-builder-service-step';
import { LocationService } from 'src/app/_services/location/location.service';
import { ServicejobCreateDto } from 'src/app/_model/servicejob';

export class JobCreateRemoteActionBuilder extends ServiceRemoteActionBuilder {
  constructor(
    private servicejobCreateDto: ServicejobCreateDto,
    appService: AppService,
    credentialsService: CredentialsService,
    locationService: LocationService,
    private logger?: LoggingService
  ) {
    super(
      appService,
      credentialsService,
      {
        endpoint: 'jobcreation',
        authenticationRequired: true,
        fifo: true,
        cachable: true,
        data: {
          accnumber: servicejobCreateDto.appaccountingnumber,
          name: servicejobCreateDto.name,
          desc: servicejobCreateDto.description,
          street: servicejobCreateDto.street,
          streetnr: servicejobCreateDto.streetnumber,
          pcde: servicejobCreateDto.zipcode,
          city: servicejobCreateDto.place,
          customername: servicejobCreateDto.customername,
          branchid: servicejobCreateDto.branchid,
        },
      },
      [new GpsRemoteActionBuilderServiceStep(locationService, logger)],
      async (data: any) => {
        this.logger.log(
          this.constructor.name,
          ' Executing post job create generate function'
        );
      },
      logger
    );
  }

  public async next(dataValues?: { key: string; value: any }[]): Promise<any> {
    return super.next(dataValues);
  }

  public async generateRemoteAction(
    dataValues: { key: string; value: any }[]
  ): Promise<RemoteAction> {
    let ra = await super.generateRemoteAction(dataValues);
    // Post processing of remote action

    ra.shortLabel = 'PAGE.DAYPROTOCOL.JOBCREATE.RA.SHORT';
    ra.shortLabelTranslate = true;

    ra.longLabel =
      (this.servicejobCreateDto.accountingnumber
        ? this.servicejobCreateDto.accountingnumber + ' - '
        : '') + (this.servicejobCreateDto.name ?? "");
    ra.longLabelTranslate = false;

    return ra;
  }
}
